import React, { useEffect, useState } from "react";
import Check from "../../Assets/check.svg";
import RightSidebar from "../../Container/RightSidebar";

import HomeStyle from "./style";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//icons
import BoxIcon1 from "../../Assets/contactIcons/call.svg";
import BoxIcon2 from "../../Assets/contactIcons/mail.svg";
import BoxIcon3 from "../../Assets/contactIcons/chat.svg";
import BoxIcon4 from "../../Assets/contactIcons/message.svg";

// -- redux
import { connect } from "react-redux";
import {
  GetContacts,
  UpdateContactStatus,
  UpdateContactOrderStatus,
} from "../../Redux/Actions/ContactUsAction";
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";

function ContactUs(props) {
  const [limit, setLimit] = useState(7);
  const [Delete, SetDelete] = useState(false);
  const [Open, SetOpen] = useState(false);
  const [Data, SetData] = useState("");
  const [InitialArray, setInitialArray] = useState([]);
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [ContactId, setContactId] = useState(false);
  const [update, SetUpdate] = useState(false);

  const initialPath = process.env.REACT_APP_IMAGE_BASE_URL;

  const [CardsArray, setCardsArray] = useState([]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(CardsArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCardsArray(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.title === arr.title);
      let id = items.filter((x) => x.id === arr.id);
      data.push({
        id: id[0].id,
        order_number: index + 1,
      });
    });
    props.UpdateContactOrderStatus(data);
  };

  const handleEdit = (e, data) => {
    e.preventDefault();
    SetData(data);
    SetOpen(true);
  };

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setContactId(id);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
    if (type === "enable_yes") {
      data = {
        id: ContactId,
        status: 0,
      };
      props.UpdateContactStatus(data);
      setTimeout(function () {
        SetUpdate(!update);
      }, 1000);
    } else {
      setModal(!OpenModal);
    }

    if (type === "disable_yes") {
      data = {
        id: ContactId,
        status: 1,
      };
      props.UpdateContactStatus(data);
      setTimeout(function () {
        SetUpdate(!update);
      }, 1000);
    } else {
      setModal(!OpenModal);
    }
  };

  useEffect(() => {
    props.GetContacts();
    props.clear("clear");
  }, [
    props.status_data,
    Delete,
    props.add_data,
    props.edit_data,
    props.delete_data,
    props.order_data,
  ]);

  useEffect(() => {
    if (props.data && props.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setInitialArray(props.data.data.data);
      setTimeout(function () {
        props.clear("");
      }, 1000);
    }
  }, [
    props.data,
    props.status_data,
    Delete,
    props.add_data,
    props.edit_data,
    props.delete_data,
    props.order_data,
  ]);

  useEffect(() => {
    props.clear("clear");
  }, []);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      setCardsArray(InitialArray);
    }
  }, [
    props.status_data,
    InitialArray,
    props.add_data,
    props.edit_data,
    props.delete_data,
    props.order_data,
  ]);

  useEffect(() => {
    if (!props.Search) {
      setCardsArray(InitialArray);
    }
    if (props.Search.length > 2) {
      const FilteredArray = InitialArray.filter((post) => {
        const postName = post.title;
        return postName.toLowerCase().includes(props.Search.toLowerCase());
      });
      setCardsArray(FilteredArray);
    }
  }, [props.Search]);

  return (
    <>
      {props.loading && <Loader />}
      {CardsArray.length > 0 ? (
        <div className="box-wrap ml-4 mr-4">
          <DragDropContext onDragEnd={handleOnDragEnd}>
            {CardsArray.map((item, index) => {
              return (
                <Droppable
                  className="box-grid m-4"
                  key={item.id}
                  droppableId={item.id.toString()}
                  type="listing"
                >
                  {(provided) => (
                    <div
                      className="box-content"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      <Draggable
                        key={item.id}
                        draggableId={item.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="h-100"
                          >
                            <div
                              className="box-content light-grey-background h-100"
                              style={{ maxHeight: "400px" }}
                            >
                              <div className="box h-100 position-relative">
                                <div className="box-header dark-background d-flex align-items-center p-3">
                                  {/* <img src={item.icon} alt="icon"/> */}
                                  <div className="contact-us-img-wrap">
                                    <img
                                      src={item.icon}
                                      alt="icon"
                                    />
                                  </div>
                                  <h6 className="text-white box-title m-0 ml-3">
                                    {item.title}
                                  </h6>
                                </div>
                                <div className="box-content p-3">
                                  <div className="d-flex justify-content-between mb-3">
                                    <div className="type">
                                      <label className="box-type-para text-grey-6 f-14 m-0">
                                        Type
                                      </label>
                                      <p className="text-white f-16 m-0">
                                        {item.type === 3 && "Service"}
                                        {item.type === 4 && "WebView"}
                                        {item.type === 6 && "Mobile"}
                                        {item.type === 7 && "Email"}
                                        {item.type === 8 && "Message"}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="text-white mb-5 pb-5">
                                    <label className="box-type-para text-grey-6 f-14 m-0">
                                      Information
                                    </label>
                                    <p className="f-16 m-0 information">
                                      {item.information}
                                    </p>
                                  </div>
                                  <div
                                    style={{ width: "90%", bottom: "15px" }}
                                    className="box-footer d-flex justify-content-between align-items-end position-absolute"
                                  >
                                    <div>
                                      <p
                                        className={
                                          item.status
                                            ? "text-green label-para f-12"
                                            : "text-grey label-para f-12"
                                        }
                                      >
                                        {item.status ? "Enabled" : "Disabled"}
                                      </p>
                                      <label className="switch mb-0">
                                        <input
                                          type="checkbox"
                                          checked={item.status}
                                          readOnly
                                        />
                                        <span
                                          className="slider round"
                                          onClick={(e) =>
                                            handleModal(
                                              e,
                                              item.status === 1
                                                ? "enable"
                                                : "disable",
                                              item.title,
                                              item.id
                                            )
                                          }
                                        />
                                      </label>
                                    </div>
                                    <button
                                      onClick={(e) => handleEdit(e, item)}
                                      className="green-background edit-button f-14"
                                    >
                                      Edit
                                    </button>
                                  </div>
                                </div>
                                <HomeStyle />
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    </div>
                  )}
                </Droppable>
              );
            })}
          </DragDropContext>
        </div>
      ) : (
        <div className="d-flex text-center justify-content-center">
          <p className="m-0 text-white">Nothing found</p>
        </div>
      )}
      <RightSidebar
        Type="Edit"
        item_data={Data}
        sidebar={Open}
        delete={() => {
          SetDelete(!Delete);
        }}
        close={() => SetOpen(false)}
        response={(e) => e}
      />
      {OpenModal && (
        <Modal
          Name={Name}
          Type={OpenModal}
          Close={(e, type) => CloseModal(e, type)}
        />
      )}
    </>
  );
}

const mapStateToProps = ({ ContactUsReducer }) => {
  const {
    loading,
    data,
    status_data,
    add_data,
    edit_data,
    delete_data,
    order_data,
  } = ContactUsReducer;
  return {
    loading,
    data,
    status_data,
    add_data,
    edit_data,
    delete_data,
    order_data,
  };
};

const mapDispatchToProps = {
  GetContacts,
  UpdateContactStatus,
  UpdateContactOrderStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
